import { render, staticRenderFns } from "./AddVirtualMachine.vue?vue&type=template&id=21becad8&scoped=true"
import script from "./AddVirtualMachine.vue?vue&type=script&lang=ts"
export * from "./AddVirtualMachine.vue?vue&type=script&lang=ts"
import style0 from "./AddVirtualMachine.vue?vue&type=style&index=0&id=21becad8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21becad8",
  null
  
)

export default component.exports